import { useRef, useEffect } from 'react'
import { CameraControls } from '@react-three/drei'
import * as THREE from 'three'
import { useFrame } from '@react-three/fiber'

interface CameraTargetVisualizerProps {
    controlsRef: React.RefObject<CameraControls>;
}

function CameraTargetVisualizer({ controlsRef }: CameraTargetVisualizerProps) {
  const targetMeshRef = useRef<THREE.Mesh>(null!)

  // Create a small red sphere (or whatever color/shape you prefer)
  const targetGeometry = new THREE.SphereGeometry(0.125, 16, 16) // small size
  const targetMaterial = new THREE.MeshBasicMaterial({
    color: 'red',
    transparent: true,
    opacity: 0.7,
  })

  // Optional: make it always visible (no depth test) so it's easy to spot
  targetMaterial.depthTest = false

  useFrame(() => {
    if (!controlsRef.current || !targetMeshRef.current) return

    // Read current target position every frame
    const target = new THREE.Vector3()
    controlsRef.current.getTarget(target)

    // Update the helper position
    targetMeshRef.current.position.copy(target)
  })

  return (
    <mesh name="camera_target"  ref={targetMeshRef} 
                                geometry={targetGeometry} 
                                material={targetMaterial} />
  )
}

export default CameraTargetVisualizer;
